import { toggleNav } from '../../js/main'
import '../../css/reset.css'
import '../../css/constants.css'
import '../../css/main.css'
import './hybrid-mixing-systems.css'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)
gsap.set(document.querySelector('body'), {
    visibility: 'visible'
})
window.addEventListener('load', () => {
    // console.log('load')
    ScrollTrigger.refresh()
})
const featuresLis = document.querySelectorAll('.features-div > ul > li');
const featureDiv = document.querySelector('.features-div');

const featuresTextPart = document.querySelector('.features-container > .text-part');

gsap.from(document.querySelectorAll('.tab'),{
    opacity: 0,
    y: 5,
    ease: 'sine',
    duration: 0.4,
    stagger: 0.2
});
gsap.from(featuresLis, { 
    x: 25,
    opacity: 0,
    ease: 'sine',
    stagger: 0.1,
    scrollTrigger: {
        trigger: featureDiv,
        start: 'top bottom-=100',
        scrub: true,
        end: 'bottom+=200 bottom',
        once: true,
        // markers: true,
        refreshPriority: 1,
    }
});

gsap.from(featuresTextPart, { 
    x: 20,
    opacity: 0,
    ease: 'sine',
    scrollTrigger: {
        trigger: featuresTextPart,
        start: 'top bottom-=100',
        scrub: true,
        end: 'bottom+=200 bottom',
        once: true,
        // markers: true
    }
});




toggleNav()
// entry()
console.log('this is hybrid mixing systems');